<div
  class="calendar"
  *ngIf="navigatorStateService.activeDate$ | async as activeDate"
  [attr.data-year]="activeDate.year"
  [attr.data-month]="activeDate.month"
>
  <app-month-navigator *ngIf="displayMonthNavigator"></app-month-navigator>
  <ng-content select="[header]"></ng-content>

  <div class="table-wrap">
    <table>
      <colgroup>
        <col />
        <col [ngClass]="getHeaderDayCss(day)" *ngFor="let day of calendarMonth" />
      </colgroup>
      <thead>
        <tr>
          <th><app-body-md bold>Name</app-body-md></th>
          <th [ngClass]="getHeaderDayCss(day)" *ngFor="let day of calendarMonth">
            {{ day.day }}<br />{{ weekdays[day.weekday - 1].substring(0, 1) }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr
          app-person-events-month-row
          [ngClass]="getRowEventCss(personEvents)"
          *ngFor="let personEvents of teamEvents"
          [memberEvents]="personEvents"
          [rowSelected]="activePersonId === personEvents.iqPersonId || _highlightedPersonId === personEvents.iqPersonId"
          [interactive]="!activePersonId || activePersonId === personEvents.iqPersonId"
          [canClickAvailableDays]="canClickAvailableDays"
          (dayClick$)="dayClick($event, personEvents)"
          [actionMenuItems]="actionMenuItems"
        ></tr>
      </tbody>
    </table>
  </div>
</div>
